import styled from 'styled-components';
import { TColorNames } from '@_shared/styles';

export const Banner = styled.section`
	width: 100%;
	padding: 10px 0px;

	position: relative;

	.slick-track {
		display: flex;
		gap: 8px;
	}
`;

// Banner 2
export const BannerItem = styled.div<{ bgColor: TColorNames }>`
	flex-shrink: 0;
	scroll-snap-align: center;

	width: 100%;
	height: 100px;

	padding: 16px;
	margin-bottom: 10px;
	border-radius: 8px;
	position: relative;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;

	background-color: ${({ theme, bgColor }) => theme[bgColor]};
`;

export const CharacterIMG1 = styled.img`
	width: 96px;

	position: absolute;
	right: 46px;
	top: 8px;
`;

export const CharacterIMG2 = styled.img`
	width: 96px;

	position: absolute;
	right: 58px;
	top: 16px;
`;

export const CharacterIMG3 = styled.img`
	width: 90px;

	position: absolute;
	right: 58px;
	top: 16px;
`;

export const BannerTitle = styled.h3`
	color: ${({ theme }) => theme['black-primary']};
	font-family: 'Pretendard';
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 140%;
`;

export const CounterContainer = styled.div`
	width: 48px;
	height: 24px;

	border-radius: 100px;
	background: rgba(30, 15, 5, 0.4);

	position: absolute;
	bottom: 26px;
	right: 36px;

	display: flex;
	justify-content: center;
	align-items: center;
`;
